import NotificationsOffOutlined from '@mui/icons-material/NotificationsOffOutlined';
import { useTheme } from '@mui/material/styles';
import { t } from 'i18next';

// Two pixels under the 18px unread badge, so the icon stays within the badge's line height.
const MUTED_ICON_SIZE_IN_PX = 16;

export default function MutedConversationIcon() {
  const theme = useTheme();

  return (
    <NotificationsOffOutlined
      aria-hidden={false}
      aria-label={t('messaging.conversation_muted')}
      data-test-id="messaging-muted-conversation-icon"
      role="img"
      sx={{
        color: theme.brandV2.colors.treadGray3,
        flexShrink: 0,
        fontSize: `${MUTED_ICON_SIZE_IN_PX}px`,
      }}
    />
  );
}
